const isOnGenericLiftKitPage = window.location.pathname === '/pages/shop-packages';
const isOnGenericWheelsTiresPage = window.location.pathname === '/pages/shop-wheels-tires-packages';
const isOnGenericPackage = isOnGenericLiftKitPage || isOnGenericWheelsTiresPage;
window.Convermax.isOnGenericPackagesPage = isOnGenericPackage;

const currentKitUrlStep = new URLSearchParams(window.location.search).get('currentPackageStep');
const isOnLiftKitPDPSelectionStep = currentKitUrlStep === 'liftPackagesStep2';
const isOnWheelPDPSelectionStep =
  currentKitUrlStep === 'liftPackagesStep3' || currentKitUrlStep === 'wheelTirePackagesStep2';
const isOnTirePDPSelectionStep =
  currentKitUrlStep === 'liftPackagesStep4' || currentKitUrlStep === 'wheelTirePackagesStep3';
const isOnAnyPDPStep = isOnLiftKitPDPSelectionStep || isOnWheelPDPSelectionStep || isOnTirePDPSelectionStep;

const liftKitsPackagesUrl = '/collections/shop-packages-lift-kits';
const wheelsTiresPackagesUrl = '/collections/shop-packages-wheels-and-tires';

const isOnSecondLiftKitPLPStep = window.location.pathname === liftKitsPackagesUrl;
const isOnSecondWheelsKitPLPStep = window.location.pathname === wheelsTiresPackagesUrl;
export const isOnSecondPLPStep = isOnSecondLiftKitPLPStep || isOnSecondWheelsKitPLPStep;

const wheelsCollectionUrl = '/collections/wheels';
const tiresCollectionUrl = '/collections/tires';

const isOnThirdLiftKitPLPStep =
  window.location.pathname === wheelsCollectionUrl && window.location.search.includes('LiftKitProductID');
const isOnTirePLPSelectionStep =
  window.location.pathname === tiresCollectionUrl && window.location.search.includes('WheelProductID');

const isOnAnyPLPStep = isOnSecondPLPStep || isOnThirdLiftKitPLPStep || isOnTirePLPSelectionStep;

export const isOnAnyStep = isOnGenericPackage || isOnAnyPLPStep || isOnAnyPDPStep;

const liftKitLsKey = 'cm_package_liftkit';
const wheelLsKey = 'cm_package_wheel';
//
const liftKitData = JSON.parse(window.Convermax.localStorage.getItem(liftKitLsKey));
const isLiftKitPackagesInProgress =
  isOnSecondLiftKitPLPStep ||
  isOnLiftKitPDPSelectionStep ||
  !!window.Convermax.localStorage.getItem(liftKitLsKey);
const wheelData = JSON.parse(window.Convermax.localStorage.getItem(wheelLsKey));

window.Convermax.getProductUrl = (url) =>
  isOnSecondLiftKitPLPStep
    ? `${url}/?currentPackageStep=liftPackagesStep2`
    : isOnThirdLiftKitPLPStep
      ? `${url}/?currentPackageStep=liftPackagesStep3`
      : isOnSecondWheelsKitPLPStep
        ? `${url}/?currentPackageStep=wheelTirePackagesStep2`
        : isOnTirePLPSelectionStep && isLiftKitPackagesInProgress
          ? `${url}/?currentPackageStep=liftPackagesStep4`
          : isOnTirePLPSelectionStep && !isLiftKitPackagesInProgress
            ? `${url}/?currentPackageStep=wheelTirePackagesStep3`
            : url;

const selectedAnotherPackageProduct = (e, startOver, url) => {
  e.preventDefault();
  e.stopPropagation();

  if (startOver && isLiftKitPackagesInProgress) {
    window.Convermax.localStorage.removeItem(liftKitLsKey);
  }
  window.Convermax.localStorage.removeItem(wheelLsKey);

  window.location.assign(url);
};

export function AfterInit() {
  const progressBar = window.document.querySelector('#cm-progress-bar');
  if (isOnAnyStep && progressBar) {
    const isVehicleSelected = window.Convermax.isVehicleSelected();
    if (!isVehicleSelected) {
      window.document.querySelector('#cm-collection-page')?.classList.add('cm_hide');
    }

    const vehicleWidget = window.document.querySelector('.cm_vehicle-widget__packages');
    if (vehicleWidget) {
      if (!isOnGenericPackage) {
        vehicleWidget.classList.add('cm_progress-bar_container');
      }

      if (isVehicleSelected) {
        vehicleWidget.classList.add('selected');
      } else {
        vehicleWidget.classList.add('not-selected', 'current');
      }
    }

    const liftKitContainer = window.document.querySelector('#cm-progress-bar_lift-kit');
    if (liftKitContainer) {
      if (isLiftKitPackagesInProgress) {
        const url = liftKitsPackagesUrl;
        const title = `2- ${liftKitData ? 'Lift Kit' : 'Choose Lift Kit'}`;

        const logoContainer = window.document.createElement('div');

        processPackageSteps(
          liftKitContainer,
          !!liftKitData && isOnAnyStep,
          (isOnSecondLiftKitPLPStep || isOnLiftKitPDPSelectionStep) && isVehicleSelected,
          url,
          logoContainer,
          title,
          liftKitData?.title,
          true,
        );
      } else {
        liftKitContainer.remove();
      }
    }

    const wheelsContainer = window.document.querySelector('#cm-progress-bar_wheels');
    if (wheelsContainer) {
      const url =
        isLiftKitPackagesInProgress && liftKitData?.id
          ? `${wheelsCollectionUrl}?LiftKitProductID/${liftKitData.id}`
          : wheelsTiresPackagesUrl;
      const title = `${isLiftKitPackagesInProgress ? '3' : '2'}- ${wheelData ? 'Wheels' : 'Pick Your Wheels'}`;

      const logoContainer = window.document.createElement('div');

      processPackageSteps(
        wheelsContainer,
        !!wheelData && isOnAnyStep,
        (isOnThirdLiftKitPLPStep || isOnSecondWheelsKitPLPStep || isOnWheelPDPSelectionStep) &&
          isVehicleSelected,
        url,
        logoContainer,
        title,
        wheelData?.title,
        !isLiftKitPackagesInProgress,
      );
    }

    const tiresContainer = window.document.querySelector('#cm-progress-bar_tires');
    if (tiresContainer) {
      tiresContainer.classList.add('cm_progress-bar_item');

      const url = wheelData?.id
        ? `${tiresCollectionUrl}?WheelProductID/${wheelData?.id}`
        : tiresCollectionUrl;
      const title = `${isLiftKitPackagesInProgress ? '4' : '3'}- Select Your Tires`;

      const logoContainer = window.document.createElement('div');

      processPackageSteps(
        tiresContainer,
        false,
        (isOnTirePLPSelectionStep || isOnTirePDPSelectionStep) && isVehicleSelected,
        url,
        logoContainer,
        title,
        false,
      );
    }

    progressBar.removeAttribute('style');
  }

  handlePDPAddToCart();
}

function processPackageSteps(
  container,
  isProductSelected,
  isCurrentStep,
  url,
  logo,
  stepTitle,
  productTitle,
  startOverOnChangeProduct,
) {
  container.classList.add('cm_progress-bar_container');
  if (isProductSelected) {
    container.classList.add('selected');
  }
  if (isCurrentStep) {
    container.classList.add('current');
  }

  container.appendChild(logo);

  const infoContainer = window.document.createElement('div');
  infoContainer.classList.add('cm_progress-bar_info');

  const stepTitleContainer = window.document.createElement('h4');
  stepTitleContainer.classList.add('cm_progress-bar_title');
  stepTitleContainer.innerHTML = stepTitle;
  infoContainer.appendChild(stepTitleContainer);

  if (isProductSelected) {
    const productTitleContainer = window.document.createElement('div');
    productTitleContainer.classList.add('cm_progress-bar_product-title');
    productTitleContainer.innerHTML = productTitle;
    infoContainer.appendChild(productTitleContainer);

    if (!isCurrentStep) {
      const changeButton = window.document.createElement('button');
      changeButton.classList.add('cm_progress-bar_reselect');
      changeButton.innerHTML = 'Change<i class="fas fa-rotate"></i>';
      changeButton.addEventListener('click', (e) =>
        selectedAnotherPackageProduct(e, startOverOnChangeProduct, url),
      );
      infoContainer.appendChild(changeButton);
    }
  }

  container.appendChild(infoContainer);
}

function handlePDPAddToCart() {
  const addToPackageBtn = window.document.querySelector('.cm_add-to-package');
  const productData = window.document.querySelector('.product-data');

  if (addToPackageBtn && productData && isOnAnyPDPStep) {
    ['.product-btn[data-add-to-cart]', '.product_other-variations', '.sticky_form'].forEach((selector) => {
      const elementToHide = window.document.querySelector(selector);
      if (elementToHide) {
        elementToHide.style = 'display: none !important;';
      }
    });

    if (isOnLiftKitPDPSelectionStep) {
      setTimeout(() => {
        const personalizer = window.document.querySelector('.product-personalizer');
        if (personalizer) {
          personalizer.style = 'display: none !important;';
        }
      }, 300);
    }

    addToPackageBtn.removeAttribute('style');
    if (isOnTirePDPSelectionStep) {
      addToPackageBtn.innerHTML = 'Add To Package And Proceed';
    }

    const { id: productId, variantId } = productData.dataset;

    addToPackageBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const cartQty = parseInt(window.document.querySelector('.qty-group_ .input_select')?.value ?? 1);

      if (isOnLiftKitPDPSelectionStep || isOnWheelPDPSelectionStep) {
        const lskey = isOnLiftKitPDPSelectionStep
          ? liftKitLsKey
          : isOnWheelPDPSelectionStep
            ? wheelLsKey
            : null;

        if (lskey) {
          const lsData = {
            id: productId,
            variantId,
            title: productData.dataset.title,
            cartQty,
          };
          window.Convermax.localStorage.setItem(lskey, JSON.stringify(lsData));
        }

        const nextUrl = isOnLiftKitPDPSelectionStep
          ? `${wheelsCollectionUrl}?LiftKitProductID/${productId}`
          : isOnWheelPDPSelectionStep
            ? `${tiresCollectionUrl}?WheelProductID/${productId}/`
            : '/';

        window.location.assign(nextUrl);
      }

      if (isOnTirePDPSelectionStep) {
        setTimeout(() => {
          const postData = [];
          if (isLiftKitPackagesInProgress) {
            postData.push({ quantity: liftKitData.cartQty, id: liftKitData.variantId });
          }
          postData.push({ quantity: wheelData.cartQty, id: wheelData.variantId });
          postData.push({ quantity: cartQty, id: variantId });

          window.Convermax.localStorage.removeItem(liftKitLsKey);
          window.Convermax.localStorage.removeItem(wheelLsKey);

          window.jQuery.ajax({
            url: '/cart/add.js',
            type: 'post',
            data: { items: postData },
            async: false,
            success: setTimeout(() => window.location.assign('/cart'), 500),
          });
        }, 300);
      }
    });
  }
}

export const vehicleWidgetRedirectUrl = isOnAnyStep
  ? isOnGenericLiftKitPage || isLiftKitPackagesInProgress
    ? liftKitsPackagesUrl
    : isOnGenericWheelsTiresPage || !isLiftKitPackagesInProgress
      ? wheelsTiresPackagesUrl
      : null
  : null;

export const onVehicleSelected = () => {
  if (isOnSecondLiftKitPLPStep || isOnSecondWheelsKitPLPStep) {
    window.document.querySelector('#cm-collection-page')?.classList.remove('cm_hide');
    if (isLiftKitPackagesInProgress) {
      window.document.querySelector('#cm-progress-bar_lift-kit')?.classList.add('current');
    } else {
      window.document.querySelector('#cm-progress-bar_wheels')?.classList.add('current');
    }
  }

  if (isOnAnyStep) {
    window.Convermax.localStorage.removeItem(liftKitLsKey);
    window.Convermax.localStorage.removeItem(wheelLsKey);
  }
};

export const onVehicleDiscarded = () => {
  if (isOnSecondLiftKitPLPStep || isOnSecondWheelsKitPLPStep) {
    window.document.querySelector('#cm-collection-page')?.classList.add('cm_hide');
    if (isLiftKitPackagesInProgress) {
      window.document.querySelector('#cm-progress-bar_lift-kit')?.classList.remove('current');
    } else {
      window.document.querySelector('#cm-progress-bar_wheels')?.classList.remove('current');
    }
  } else if (isOnAnyStep) {
    window.location.assign(vehicleWidgetRedirectUrl);
  }
};

export const Widgets = [
  {
    name: 'HeaderVehicleWidget_packages',
    type: 'VehicleWidget',
    location: {
      replace: '#cm_shop-packages-vehicle, #cm-progress-bar_ymm',
      class: 'cm_vehicle-widget__packages',
    },
    template: 'fitmentSearch/packagesVehicleWidget',
    visibleIf: () => isOnAnyStep,
    isAlwaysActive: isOnGenericPackage,
    columnBreakpoint: 600,
    doNotRedirectOnVehicleSelect: !isOnGenericPackage,
    redirectUrl: vehicleWidgetRedirectUrl,
  },
];
